"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _uiBox = _interopRequireDefault(require("ui-box"));

var Tablist =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Tablist, _PureComponent);

  function Tablist() {
    (0, _classCallCheck2.default)(this, Tablist);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Tablist).apply(this, arguments));
  }

  (0, _createClass2.default)(Tablist, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_uiBox.default, (0, _extends2.default)({
        role: "tablist"
      }, this.props));
    }
  }]);
  return Tablist;
}(_react.PureComponent);

exports.default = Tablist;
Tablist.displayName = "Tablist";
(0, _defineProperty2.default)(Tablist, "propTypes", (0, _objectSpread2.default)({}, _uiBox.default.propTypes));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy90YWJzL3NyYy9UYWJsaXN0LmpzIl0sIm5hbWVzIjpbIlRhYmxpc3QiLCJwcm9wcyIsIlB1cmVDb21wb25lbnQiLCJCb3giLCJwcm9wVHlwZXMiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBOztBQUNBOztJQUVxQkEsTzs7Ozs7Ozs7Ozs7OzZCQUtWO0FBQ1AsYUFBTyw2QkFBQyxjQUFEO0FBQUssUUFBQSxJQUFJLEVBQUM7QUFBVixTQUF3QixLQUFLQyxLQUE3QixFQUFQO0FBQ0Q7OztFQVBrQ0Msb0I7OztBQUFoQkYsTzs4QkFBQUEsTywrQ0FFZEcsZUFBSUMsUyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBQdXJlQ29tcG9uZW50IH0gZnJvbSAncmVhY3QnXG5pbXBvcnQgQm94IGZyb20gJ3VpLWJveCdcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgVGFibGlzdCBleHRlbmRzIFB1cmVDb21wb25lbnQge1xuICBzdGF0aWMgcHJvcFR5cGVzID0ge1xuICAgIC4uLkJveC5wcm9wVHlwZXNcbiAgfVxuXG4gIHJlbmRlcigpIHtcbiAgICByZXR1cm4gPEJveCByb2xlPVwidGFibGlzdFwiIHsuLi50aGlzLnByb3BzfSAvPlxuICB9XG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/tabs/src/Tablist.js
// module id = 211
// module chunks = 0